import styled from 'styled-components';

import variables from '../../../../styles/variables';

export const Specs = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 2rem;
`;

export const SpecRoundEdgeBox = styled.div`
  border: ${variables.colorGreyDark} 1px solid;
  border-radius: 5px;
  margin-bottom: 15px;
`;

export const MainTitle = styled.p`
  font-size: 18px;
  line-height: 14px;
  font-weight: 600;
  letter-spacing: normal;
  margin: 0;
  padding: 1rem 0;
  @media screen and (max-width: 415px) {
    font-size: 16px;
  }
`;
export const SpecSectionTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.5px;
  padding-top: 26px;
  padding-bottom: 6px;
  margin: 0;
`;

export const SpecSection = styled.div``;

export const SpecRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding: 16px 0 16px 20px;
  box-sizing: border-box;
  @media screen and (max-width: 415px) {
    display: block;
  }
`;
export const SpecBottomLine = styled.div`
  border-bottom: ${variables.colorGreyMedium} 1px solid;
`;

export const SpecSectionLabel = styled.p`
  font-size: 14px;
  letter-spacing: 0.4px;

  margin: 0;
  padding-right: 1rem;
  line-height: 20px;
`;

export const SpecSectionDetail = styled.p`
  font-size: 14px;
  letter-spacing: 0.5px;

  margin: 0;
  @media screen and (max-width: 415px) {
    margin-top: 4px;
  }
`;
